import React from 'react';

function NotFound(props) {
  return <div>Not Found!</div>;
}

export default NotFound;
